import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, of } from 'rxjs';

import { environment } from 'src/environments/environment';
import { setServerUtcOffsetMinutes } from '../shared/utils/system-date.util';

@Injectable({ providedIn: 'root' })
export class ServerClockService {
  private readonly url = `${environment.apis.unified.baseUrl}/system/time-info`;

  constructor(private _http: HttpClient) { }

  // Busca o fuso do servidor para exibir os carimbos de data/hora em horário de Brasília.
  // Se falhar, mantém o padrão (servidor em UTC) sem incomodar o usuário.
  load(): void {
    this._http
      .get<{ UtcOffsetMinutes?: number; utcOffsetMinutes?: number }>(this.url, {
        headers: new HttpHeaders({ 'X-Skip-Error-Handler': 'true' })
      })
      .pipe(catchError(() => of(null)))
      .subscribe((info) => {
        const minutes = info?.UtcOffsetMinutes ?? info?.utcOffsetMinutes;

        if (typeof minutes === 'number') {
          setServerUtcOffsetMinutes(minutes);
        }
      });
  }
}
